import { Box, styled } from "@mui/material";
import UploadBlackIcon from "../../Assets/Icons/upload-black.svg";
import CloseCircleFullIcon from "../../Assets/Icons/close-circle-full.svg";
import { useDropzone } from "react-dropzone";
import { useCallback, useEffect, useState } from "react";
import useFetchAuthImage from "../../Hooks/useFetchAuthImage";

const ImageContainer = styled(Box)(({ disabled }) => ({
  border: disabled ? "1px dashed #dedede" : "1px dashed #fb4764",
  padding: "16px",
  borderRadius: "16px",
  marginBottom: "28px",
}));

const ImagePlaceholder = styled(Box)(({ isUploaded }) => ({
  width: "102px",
  height: "92px",
  borderRadius: "16px",
  border: "1px solid #d9d9d9",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  color: "#b3b3b3",
  fontWeight: 500,
  cursor: isUploaded ? "default" : "pointer",
  position: "relative",
}));

const ImageUpload = ({
  onUpload,
  imageInputFile,
  serverImageUrl,
  disabled,
}) => {
  const { data: serverImageUrlData } = useFetchAuthImage({
    path: serverImageUrl,
  });

  const [imageUrl, setImageUrl] = useState(null);

  const onDrop = useCallback(
    (acceptedFiles) => {
      onUpload?.(acceptedFiles[0]);
    },
    [onUpload]
  );

  const { getRootProps, getInputProps } = useDropzone({
    disabled,
    onDrop,
    accept: {
      "image/*": [],
    },
    multiple: false,
  });

  useEffect(() => {
    if (serverImageUrlData) {
      setImageUrl(serverImageUrlData);
    }
  }, [serverImageUrlData]);

  useEffect(() => {
    if (imageInputFile) {
      setImageUrl(URL.createObjectURL(imageInputFile));
    }
  }, [imageInputFile]);

  if (imageUrl) {
    return (
      <ImageContainer disabled={disabled}>
        <ImagePlaceholder isUploaded>
          <img
            src={imageUrl}
            alt="uploaded-image"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "16px",
            }}
          />

          <img
            src={CloseCircleFullIcon}
            alt="close-image"
            style={{
              position: "absolute",
              top: 6,
              right: 6,
              cursor: disabled ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              onUpload?.(null);
              setImageUrl(null);
            }}
          />
        </ImagePlaceholder>
      </ImageContainer>
    );
  }

  return (
    <ImageContainer {...getRootProps()}>
      <input {...getInputProps()} />
      <ImagePlaceholder>
        <img src={UploadBlackIcon} alt="upload-black" />
        Add
      </ImagePlaceholder>
    </ImageContainer>
  );
};

export default ImageUpload;
